export default defineAppConfig({
    // webServiceUrl: "https://ws-tests.mecanobox.fr/get.ws"
})